import React, { useEffect } from "react";
import "./ThisPF.css";

import Mockup1 from "../../assets/ThisPortfoilio.png";

function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function ThisPF() {
  useScrollReveal();

  return (
    <main className="project-page thispf">

      {/* ================= HERO ================= */}
      <section className="hero reveal">
        <div className="hero-copy">
          <p className="hero-kicker">Personal project · Portfolio</p>

          <h1 className="hero-title">
            My Portfolio Project
            <span className="hero-title-accent">
              {" "}Creative Development
            </span>
          </h1>

          <p className="hero-body">
            This project showcases my approach to design and development,
            focusing on clean layouts, smooth interactions and a clear visual
            hierarchy.
            <br /><br />
            The goal was to present my work in a way that feels modern,
            structured and engaging.
          </p>

          <div className="hero-tags">
            <span>React</span>
            <span>UX/UI</span>
            <span>Frontend</span>
          </div>
        </div>

        <div className="hero-image">
          <div className="hero-mockup-frame">
            <img src={Mockup1} alt="Project mockup" />
          </div>
        </div>
      </section>

      {/* ================= PROJECT DESCRIPTION ================= */}
      <section className="project-section reveal">
        <h2>Project Overview</h2>
        <p className="large-text">
          This portfolio project was built to highlight both visual design
          and technical execution. The layout is modular and reusable,
          making it easy to scale with future projects.
        </p>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="project-section reveal">
        <h2>Process</h2>

        <div className="columns-3">
          <div className="journey-card">
            <h3>Planning</h3>
            <p>
              Defined goals, structure and overall tone for the portfolio
              before starting development.
            </p>
          </div>

          <div className="journey-card">
            <h3>Design</h3>
            <p>
              Created layouts focusing on clarity, spacing and consistency
              across all project pages.
            </p>
          </div>

          <div className="journey-card">
            <h3>Development</h3>
            <p>
              Built with React and reusable components, with scroll-based
              animations for added depth.
            </p>
          </div>
        </div>
      </section>

    </main>
  );
}
